(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  class HeroProductPins extends HTMLElement {
    constructor() {
      super();
      this.bindEvents();
      this.supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
    }

    bindEvents() {
      Array.from(this.querySelectorAll('.hero-collage__tooltip-wrapper')).forEach((pin) => {
        console.log(pin.querySelector('a.hero-collage__pin'));
        pin.querySelector('a.hero-collage__pin').addEventListener('click', this.handleClick.bind(this));
        pin.querySelector('a.hero-collage__pin').addEventListener('mouseover', this.hoverElement.bind(this));
        pin.addEventListener('mouseleave', this.mouseLeave.bind(this));
      });
    }

    handleClick(e) {
      if (this.supportsTouch) {
        e.preventDefault();
        if (e.currentTarget.parentNode.classList.contains('active')) {
          e.currentTarget.parentNode.classList.remove('active');
        } else {
          var activePin = document.querySelector('.hero-collage__tooltip-wrapper.active');
          if (activePin) {
            activePin.classList.remove('active');
          }
          e.currentTarget.parentNode.classList.add('active');
        }
      }
    }

    hoverElement(e) {
      if (!this.supportsTouch) {
        e.currentTarget.parentNode.classList.add('active');
      }
    }

    mouseLeave(e) {
      if (!this.supportsTouch) {
        e.currentTarget.classList.remove('active');
      }
    }
  }

  customElements.define('hero-product-pins', HeroProductPins);

  } catch(e) { console.error(e); }
})();
})();
